import { Injectable } from "@angular/core";
import { ComponentStore } from "@ngrx/component-store";
import { Observable } from "rxjs";
import { GameFilterCategoriesConfig } from '../../games-filter/games-filter-categories.models';
import { RewardsModalConfig } from "../../rewards/rewards.models";
import { ModalsState, initialState } from "./modals.model";

@Injectable({
  providedIn: "root",
})
export class ModalsStore extends ComponentStore<ModalsState> {

  constructor() {
    super(initialState);
  }

  /*
   * Selectors read state out of our component store
   */
  readonly gameFilterCategoriesConfig$: Observable<GameFilterCategoriesConfig> = this.select(
    (state) => state.gameFilterCategoriesConfig
  );
  readonly rewardsModalConfig$: Observable<RewardsModalConfig> = this.select(
    (state) => state.rewardsModalConfig
  );
  readonly menuModalConfig$: Observable<string> = this.select(
    (state) => state.modalMenuConfig
  );

  /*
   * Updaters act as reducers as such and add values to our component state
   */
  readonly changeGameFilterCategoriesConfig = this.updater((state, configuration: GameFilterCategoriesConfig) => ({
    ...state, gameFilterCategoriesConfig: configuration
  }));
  readonly changeRewardsModalConfig = this.updater((state, configuration: RewardsModalConfig) => ({
    ...state, rewardsModalConfig: configuration
  }));
  readonly changeMenuModalConfig = this.updater((state, configuration: string) => ({
    ...state, modalMenuConfig: configuration
  }));
}
